import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import queryString from "query-string";
import Chip from "@mui/material/Chip";
import {
  useSetRecoilState,
  useRecoilValue,
  useRecoilState,
  useResetRecoilState,
} from "recoil";
import {
  showModalEditFiltersProcState,
  showModalEditFiltersState,
} from "../store/reservation/reservationState";
import {
  filterSearchSelectedState,
  filtersMappedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../SearchHours/state/atoms";
import useSearchHours from "./hooks/useSearchHours";
import { isChangeCovenantFilterState } from "./components/autocompletes/state/atoms";
import { dayDefaultAvailableState } from "./components/calendars/state/atoms";
import { useLocation } from "react-router-dom";
import ManageStorage from "src/shared/global/manageStorage";

const FiltersSearch = () => {
  const classes = useStyles();
  const location = useLocation();
  const setShowModalEditFiltersProc = useSetRecoilState(
    showModalEditFiltersProcState,
  );
  const setShowModalEditFilters = useSetRecoilState(showModalEditFiltersState);
  const filtersMapped = useRecoilValue(filtersMappedState);
  const [filterSearchSelected, setFiltersSearchSelected] = useRecoilState(
    filterSearchSelectedState,
  );
  const { loadDaysAvailableAndDefault, isEmptyFilters } = useSearchHours();
  const setIsChangeCovenantFilter = useSetRecoilState(
    isChangeCovenantFilterState,
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState,
  );
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState,
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState,
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const query = queryString.parse(location.search);

  const handleModal = () => {
    const page = ManageStorage.getValueFromStorage("currentUrl");
    const actualPage = `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`;

    if (page === actualPage) {
      setShowModalEditFilters(true);
    } else {
      setShowModalEditFiltersProc(true);
    }
  };

  const handleDeleteFilter = (filterName) => (e) => {
    setFiltersSearchSelected({
      ...filterSearchSelected,
      [filterName]: {
        ...filterSearchSelected[filterName],
        value: "",
        code: null,
      },
    });

    if (filterName === "covenantSelected") {
      setIsChangeCovenantFilter(true);
      resetProfessionalsMatchCovenant();
      resetProfessionalsNoMatchCovenant();
    }

    if (filterName === "professionalSelected") {
      setIsChangeCovenantFilter(true);
      resetHoursAvailable();
      resetDayDefaultAvailable();
      setTimeout(async () => {
        await loadDaysAvailableAndDefault();
      }, 100);
    }
  };

  return (
    <Grid className={classes.root} container marginBottom={3}>
      <Grid container p={2}>
        <Grid style={{ color: "#4B5563", fontWeight: 600 }} item xs={6} md={6}>
          Filtros de búsqueda
        </Grid>
        {/* {
                    query && Object.keys(query).length === 0 && query.ra_id !== "" && (
                        <Grid style={{ textAlign: 'right', cursor: 'pointer' }} item xs={6} md={6} onClick={() => handleModal()}>
                            <Typography variant="subtitle2">
                                Editar
                            </Typography>
                        </Grid>
                    )
                } */}
        <Grid
          style={{ textAlign: "right", cursor: "pointer" }}
          item
          xs={6}
          md={6}
          onClick={() => handleModal()}
        >
          <Typography variant="subtitle2">Editar</Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} p={2}>
        <Stack direction="row" spacing={1} display={"block"}>
          {filtersMapped.length === 0 && (
            <Typography variant="h6">No se han seleccionado filtros</Typography>
          )}
          {filtersMapped.map((el, index) => {
            let props = {
              key: index,
              style: { marginLeft: 0, marginRight: "8px", marginBottom: 5 },
              label: el.value,
            };

            if (
              el.hasOwnProperty("canDeleteFilter") &&
              el.canDeleteFilter === true &&
              filtersMapped.length > 1 &&
              !isEmptyFilters()
            ) {
              props["onDelete"] = handleDeleteFilter(el.nameProperty);
            }

            return el.value !== "" && <Chip {...props} />;
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: "white",
    borderRadius: "8px",
    marginBottom: 10,
    boxShadow:
      "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);",
  },
});

export default FiltersSearch;
